export enum ProductTier {
	Standard = 'standard',
	Plus = 'plus'
}
